import { useContext } from "react"
import styled from "styled-components"
import { useT } from "react-polyglot-hooks"
import { SecondaryButton } from "components/styled/Buttons/SecondaryButton"
import Icon from "components/icons/icon"
import { Play2 } from "components/icons/play2"
import { sendEvent } from "scripts/GoogleAnalytics"
import { Panorama } from "components/icons/panorama"
import { SliderContext } from "scenes/CarScene/Header/SliderContext"
import { CarContext } from "../CarContext"

const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  margin-bottom: 25px;

  > :first-child {
    margin-right: 25px;
    margin-bottom: 15px;
  }

  > button {
    width: auto;
    margin: 0;
    text-transform: uppercase;
  }

  svg {
    flex: 0 0 auto;
  }
`

const PlayIcon = styled(Icon)`
  margin-left: 5px;
  margin-top: 2px;
`

function Actions() {
  const t = useT()
  const {
    page,
    showMedia,
    setShowMedia,
    car: { youtubeId, panoramaConfig }
  } = useContext(CarContext)
  const { selectedMedia, slideToVideo } = useContext(SliderContext)

  const showVideo = selectedMedia === "video" && showMedia !== "panorama"
  const showPanorama = showMedia === "panorama" || selectedMedia === "panorama"

  const goToVideo = () => {
    sendEvent("Video", { event_category: page, event_label: "play CTA" })
    slideToVideo()
    setShowMedia("video")
  }

  const goToPanorama = () => {
    sendEvent("360º photos", { event_category: page, event_label: "360º photos" })
    setShowMedia("panorama")
  }

  if (!youtubeId && !(panoramaConfig && panoramaConfig.enabled)) return null

  return (
    <Wrapper>
      {panoramaConfig && panoramaConfig.enabled && (
        <SecondaryButton size="sm" onClick={goToPanorama} border disabled={showPanorama}>
          {t("car_data.panorama.view")}
          <PlayIcon Icon={Panorama} viewBox="0 0 24 24" />
        </SecondaryButton>
      )}
      {youtubeId && (
        <SecondaryButton size="sm" onClick={goToVideo} border disabled={showVideo}>
          {t("car_data.video.view")}
          <PlayIcon Icon={Play2} />
        </SecondaryButton>
      )}
    </Wrapper>
  )
}

export default Actions
